import { useYMapEntries } from './useYMapEntries';
import { yLines } from '../schema';
import { getDiagramDoc } from '../doc';

export function useLines() {
    const doc = getDiagramDoc();
    return useYMapEntries(doc ? yLines(doc) : null);
}
